// extracted by mini-css-extract-plugin
export default {"imageWrapper":"DF-z","hovered":"EF-z","hoverImage":"FF-z","mainImage":"GF-z","imageNoBackground":"HF-z","fullSizeImage":"IF-z"};